import React, { useState, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import AirdropForm from './airdrop';
import UserSubmissions from './userSubmissions';

const AirdropDashboard = ({ }) => {
 

  const [dataCoinTab] = useState([
    {
      id: 1,
      title: 'Airdrop',
      icon: 'fa-usd'
    },
    {
      id: 2,
      title: ' My Submissions',
      icon: 'fa-user'
    }


  ]);
  return (
    <div style={{marginBottom: 150}}>
      <section className="wallet buy-crypto flat-tabs">
        <div className="container">
          <div className="row">
            <Tabs>
              <TabList>
                {
                  dataCoinTab.map(idx => (
                    <Tab key={idx.id}>  <i className={`fa ${idx.icon}`}></i> {` ${idx.title}`}</Tab>
                  ))
                }
              </TabList>

              <TabPanel>
                <AirdropForm
                />
              </TabPanel>
              <TabPanel>
                <UserSubmissions />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </section> 

    </div>
  );

};

export default AirdropDashboard;
